import { useRef, useState } from "react";

export default function ReminderCompletionButton({ reminder, onComplete, label, style }) {
  const lock = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const done = reminder.status === "done";
  const blocked = reminder.type === "consultant_reply_required";
  const complete = async event => {
    event.stopPropagation();
    if (lock.current || done) return;
    if (blocked) { setError("Responda ao cliente para concluir esta pendência."); return; }
    lock.current = true;
    setBusy(true);
    setError("");
    try { await onComplete(reminder.id); }
    catch (failure) { setError(failure?.message || "Não foi possível concluir. Tente novamente."); }
    finally { lock.current = false; setBusy(false); }
  };
  return <span style={{ display:"inline-flex", flexDirection:"column", alignItems:"flex-start" }}
    onClick={event => event.stopPropagation()}>
    <button type="button" role="checkbox" aria-checked={done}
      aria-label={label || "Marcar lembrete como feito"}
      aria-busy={busy} disabled={busy || done}
      title={blocked ? "Responda ao cliente para concluir esta pendência." : busy ? "Salvando conclusão…" : undefined}
      onClick={complete} style={style}>{done ? "✓" : busy ? "…" : ""}</button>
    {busy && <span role="status" style={{ fontSize:10 }}>Salvando…</span>}
    {error && <span role="alert" style={{ fontSize:11, color:"#B42318", maxWidth:220 }}>{error}</span>}
  </span>;
}
